import { createFileRoute, redirect } from "@tanstack/react-router";
import { PackagesPage } from "@majourneys/booking";
import { activitiesApi } from "../../../features/activities/api/activities.api";
import { activityKeys } from "../../../features/activities/constants/query-keys";
import { checkoutBlockReason, type CheckoutActivity } from "../../../features/activities/lib/checkout-guard";
import { transferHubRedirect } from "../../../features/transport/lib/hub-redirect";
import { withApi404 } from "../../../lib/route-loader";

export const Route = createFileRoute("/$lang/_layout/$slug/packages")({
  loader: ({ params, context }) =>
    withApi404(async () => {
      const { queryClient } = context;
      const lang = params.lang;
      const response = await queryClient.ensureQueryData({
        queryKey: activityKeys.detail(params.slug, lang),
        queryFn: () => activitiesApi.getBySlug(params.slug, lang),
      });
      const a = response.data as CheckoutActivity & {
        slug?: string;
        template?: string | null;
        typePrice?: number;
        category?: { slug?: string | null } | null;
      };
      const hub = transferHubRedirect(a, params.lang);
      if (hub) throw redirect(hub);
      // A restaurant table is booked from the sheet on its page (free, no
      // packages, no totals) and an editorial place is not booked at all, so
      // an old or typed link here goes back to the page, choices kept. A flow
      // page, so a normal redirect, as on checkout.
      const blocked = checkoutBlockReason(a);
      if (blocked === "restaurant" || blocked === "explore") {
        throw redirect({
          to: "/$lang/$slug",
          params,
          search: (prev: Record<string, unknown>) => prev,
        });
      }
      if (a.template === "stay" || a.typePrice === 2) {
        throw redirect({
          to: "/$lang/$slug/details",
          params,
          search: (prev: Record<string, unknown>) => prev,
        });
      }
      return null;
    }),
  component: PackagesPage,
});
